import React from 'react'
import Chart from 'react-apexcharts'
import { ApexOptions } from 'apexcharts'
import { Title } from '../Tables/styles'
import { useCustomTheme } from '../../../context/Theme/ThemeContextData'

interface StockTotalChartProps {
  atual: number
  anterior: number
}

export default function StockTotalChart({ atual, anterior }: StockTotalChartProps) {
  const { theme } = useCustomTheme()
  const isLight = theme === 'light'

  const series = [
    {
      name: 'Volume (Caixas)',
      data: [Math.round(anterior), Math.round(atual)],
    },
  ]

  const options: ApexOptions = {
    chart: {
      type: 'bar',
      height: 300,
      toolbar: { show: false },
      fontFamily: 'Montserrat, sans-serif',
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '40%',
        borderRadius: 8,
        distributed: true,
        dataLabels: {
          position: 'top',
        },
      },
    },

    dataLabels: {
      enabled: true,
      formatter: (val: number) => `${val.toLocaleString('pt-BR')} cx`,
      offsetY: -25,
      style: {
        fontSize: '14px',
        fontWeight: 'bold',
        colors: [isLight ? '#0f172a' : '#ffffff'],
      },
    },
    xaxis: {
      categories: ['Mês Anterior', 'Mês Atual'],
      labels: {
        style: { colors: isLight ? '#0f172a' : '#ffffff', fontSize: '14px', fontWeight: 'bold' },
      },

      axisBorder: { show: false },
      axisTicks: { show: false },
    },
    yaxis: {
      show: false,
    },
    grid: {
      show: false,
      padding: {
        top: 30,
      },
    },
    colors: ['rgb(9, 72, 197)', '#a6c10b'],
    legend: { show: false },
    tooltip: {
      enabled: true,
      y: {
        formatter: (val: number) => `${val.toLocaleString('pt-BR')} cx`,
      },
    },
  }

  return (
    <div
      style={{
        backgroundColor: isLight ? '#ffffff' : 'rgba(0, 0, 0, 0.2)',
        padding: '20px',
        borderRadius: '20px',
        border: isLight ? '1px solid #cbd5e1' : 'none',
        borderLeft: '5px solid #a6c10b',
        boxShadow: isLight ? '0 4px 20px rgba(0, 0, 0, 0.05)' : '0 4px 15px rgba(0,0,0,0.2)',
        marginBottom: '20px',
      }}
    >
      <Title>Estoque</Title>
      <Chart options={options} series={series} type='bar' height={250} />
    </div>
  )
}
